var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSynchPayRightSideLogo = function SvgSynchPayRightSideLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#100E12",
    d: "M21.006 24.991c9.269 0 17.342 5.035 21.678 12.495a24.9 24.9 0 0 0 3.364-12.495C46.048 11.19 34.835 0 21.006 0H0v24.991ZM21.006 50.98H0v24.991h21.006c13.829 0 25.042-11.19 25.042-24.991 0-4.551-1.233-8.841-3.364-12.496-4.336 7.46-12.409 12.496-21.678 12.496"
  })));
};
export default SvgSynchPayRightSideLogo;